// extracted by mini-css-extract-plugin
module.exports = {"box":"index_box_3ePbw","item":"index_item_3IIij","itemMain":"index_itemMain_1Ex3n","icon":"index_icon_2T9Nh","add":"index_add_3hzLc","addIcon":"index_addIcon_Zf5o-"};